import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '.';

interface LocalConfigProps {
  isModalOpen: boolean;
  leadId: string;
  error: boolean;
  errorMessage: {
    code: number;
    message: string;
  };
}

const initialState: LocalConfigProps = {
  isModalOpen: false,
  leadId: '',
  error: false,
  errorMessage: {
    code: 0,
    message: '',
  },
};

const localConfigSlice = createSlice({
  name: 'localConfig',
  initialState,
  reducers: {
    setModalIsOpen: (state) => {
      return { ...state, isModalOpen: true };
    },
    setModalIsClose: (state) => {
      return { ...state, isModalOpen: false, leadId: '', error: false };
    },
    setLeadId: (state, action) => {
      return { ...state, error: false, leadId: action.payload };
    },
    setError: (state, action) => {
      return { ...state, leadId: '', error: true, errorMessage: action.payload };
    },
  },
});

export const selectLocalConfig = (state: RootState) => state.localConfig;

export const { setModalIsOpen, setModalIsClose, setLeadId, setError } = localConfigSlice.actions;

export default localConfigSlice.reducer;
